<template>
  <portal to="mapbox-popup">
    <slot :marker="marker">
      Empty
    </slot>
  </portal>
</template>

<script>
export default {
  inject: ['registerClickedMarkerListener'],
  data() {
    return {
      marker: null,
    };
  },
  mounted() {
    this.registerClickedMarkerListener(this.updatePopupContent);
  },
  methods: {
    updatePopupContent(payload) {
      this.marker = payload;
    },
  },
};
</script>
